// # Subscription Types Configuration
export const SUBSCRIPTION_TYPES = {
  STEP1_LIBRARY: {
    id: 'step1_library',
    name: 'Library Access Step 1',
    description: 'Access to Step 1 library content',
    requiresMentor: false
  },
  STEP2_LIBRARY: {
    id: 'step2_library',
    name: 'Library Access Step 2',
    description: 'Access to Step 2 library content',
    requiresMentor: false
  },
  STEP1_MENTORSHIP: {
    id: 'step1_mentorship',
    name: 'Step 1 Mentorship',
    description: 'Access to Step 1 Mentorship and library',
    requiresMentor: true
  },
  STEP2_MENTORSHIP: {
    id: 'step2_mentorship',
    name: 'Step 2 Mentorship',
    description: 'Access to Step 2 Mentorship and library',
    requiresMentor: true
  },
  // # Add new OET subscription type
  OET: {
    id: 'OET',
    name: 'Occupation English Test',
    description: 'Access to OET preparation resources and mentorship',
    requiresMentor: true
  },
  // # Add new US_VISA_Counselling subscription type
  US_VISA_COUNSELLING: {
    id: 'US_VISA_Counselling',
    name: 'US VISA Counselling',
    description: 'Access to US VISA counselling services and mentorship',
    requiresMentor: true
  }
};

export const DURATION_UNITS = [
  { value: 'minutes', label: 'Minutes' },
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' }
];

// # Add subscription status types
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired',
  PENDING: 'pending'
}; 